// extracted by mini-css-extract-plugin
export default {"wrapper":"Emails_wrapper__720MP","add":"Emails_add__AhCgh"};